// extracted by mini-css-extract-plugin
export var countries = "flags-module--countries--2128d";
export var country = "flags-module--country--659f6";
export var flags = "flags-module--flags--a09b9";
export var flagsBlack = "flags-module--flagsBlack--eca18";
export var flagsWhite = "flags-module--flagsWhite--97357";
export var icon = "flags-module--icon--f7959";
export var wrapper = "flags-module--wrapper--fc6b1";